import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IndicativeLoanOffer, IndicativeLoanOfferStatusCode } from '../../model/cibil/indicative-loan.model';
import { CreditAssessmentService } from '../../service/credit-assessment.service';
import { Router } from '@angular/router';
import { Keys, StorageService } from '../../service/storage.service';
import { CreditBureauService } from '../../service/credit-bureau.service';
import { Logger } from '../../utils/Logger';
import { Toaster, Type } from '../../toaster/Toaster';
import { CreditBureauName, CreditReportFetchResponse } from '../../model/cibil/credit-bureau.model';
import { LoanApplicationTransition } from '../../model/LoanApplicationTransition';
import { LoanApplicationService } from '../../service/loan-application.service';
import { LoansAndApplicationsSegregator } from '../borrower-dashboard/all-loans-and-applications/loans-and-applications-segregator';
import { LoanDetailsService } from '../../service/loan-details.service';
import { ConfigService } from '../../service/config.service';
const GaugeChart = require('gauge-chart');

@Component({
  selector: 'app-cibil-dashboard',
  templateUrl: './cibil-dashboard.component.html',
  styleUrls: ['./cibil-dashboard.component.css']
})
export class CibilDashboardComponent implements OnInit, AfterViewInit {
  public isQuickCashAvailable: boolean = false;
  public isApplyNowClicked: boolean = false;
  public indicativeLoan: IndicativeLoanOffer;
  public creditScore: number;
  public monthlyIncome: number;
  public employmentType: string;
  public creditReportId: string;
  public email: string;
  public showNoLoanOffer: boolean;
  public showNormalPersonalLoan: boolean;
  public panCard: string;
  public cibilReportText: string;
  public fileContent: string;
  public fileName: string;
  public creditBureauUniqueReferenceId: string;
  public isNoHistory: boolean = false;
  public minimumSalariedIncome: number = this.configService.getMinimumSalariedIncome();

  constructor(
    private readonly creditAssessmentService: CreditAssessmentService,
    private readonly creditBureauService: CreditBureauService,
    private readonly loanApplicationService: LoanApplicationService,
    private readonly loanDetailsService: LoanDetailsService,
    private readonly segregator: LoansAndApplicationsSegregator,
    private readonly router: Router,
    private readonly storageService: StorageService,
    private readonly configService: ConfigService
  ) { }

  async ngOnInit(): Promise<void> {
    this.handleRouteData();
    await this.getCibilReportContent();
    // this.getAllCreditReportsOfLenderByPanCard();
  }

  ngAfterViewInit(): void {
    this.setGaugeChartValues();
  }

  public async quickCashAvailabilityCheckForUser(event: any): Promise<void> {
    this.isQuickCashAvailable = event;
    if (!this.isQuickCashAvailable && this.creditReportId && this.monthlyIncome) {
      await this.checkIndicativeLoanOffer(this.creditReportId, this.monthlyIncome);
    }
  }

  public async applyNowClicked(event: any): Promise<void> {
    this.isApplyNowClicked = event;
    if (this.isApplyNowClicked) {
      this.removeLoanApplicationFromLocalStorage();
      try {
        const userId = this.storageService.getItem(Keys.PROFILE_ID);
        const [loanApplications, loans] = await Promise.all([
          await this.loanApplicationService.getLoanApplicationsByUserId(userId),
          await this.loanDetailsService.getLoansByUserId(userId)
        ]);
        const loanApplicationIds = loanApplications.map(loanApplication => loanApplication.id);
        const transitions: LoanApplicationTransition[] = await this.loanApplicationService.getAllTransitionsByLoanApplicationIds(loanApplicationIds);
        const yetToBeSubmittedLoanApplications = this.segregator.filterYetToBeSubmittedLoanApplications(loanApplications, transitions);
        const oldRejectedApplications = this.segregator.filterOldRejectedLoanApplications(loanApplications, loans, transitions);
        const oldRejectedApplicationsIds: Set<string> = new Set<string>(oldRejectedApplications.map(loan => loan.id));
        const allAtLeastSanctionedLoanApplicationIds: Set<string> = new Set<string>(loans.map(loan => loan.loanApplicationId));
        const yetToBeSanctionedLoanApplications = loanApplications.filter(loanApplication => (!allAtLeastSanctionedLoanApplicationIds.has(loanApplication.id) && !oldRejectedApplicationsIds.has(loanApplication.id)));

        if (yetToBeSubmittedLoanApplications && yetToBeSubmittedLoanApplications.length) {
          Toaster.toast('Hurray! You have already an loan in progress.', Type.Success);
          this.router.navigate([`/borrow/application/${yetToBeSubmittedLoanApplications[0].id}`]);
        } else if (yetToBeSanctionedLoanApplications && yetToBeSanctionedLoanApplications.length) {
          Toaster.toast('Hurray! You have already an loan in progress.', Type.Success);
          this.router.navigate([`/borrow/dashboard/applications`]);
        } else if (this.indicativeLoan) {
          const navigationExtras: any = {
            state: { 
              'amount': this.indicativeLoan.amount, 
              'tenure': this.indicativeLoan.tenure, 
              'createLoanApplicationType': CreditBureauName.CIBIL,
              'creditReportId': this.creditReportId,
              'creditOptionId': this.indicativeLoan.creditOptionId
            }
          };
          this.storageService.saveItem(Keys.SHOULD_EMAIL_FIELD_DISABLED, true.toString());
          this.router.navigate(['/borrow/loan-info'], navigationExtras);
        } else {
          this.router.navigate(['/borrow/loan-info']);
        }
      } catch (err) {
        console.log(err)
        Toaster.toast('Sorry! Something went wrong. Cannot apply loan now.', Type.Error);
      }

    }
  }

  public saveFile() {
    var blob = this.b64toBlob(this.fileContent, "application/pdf");
    let a = document.createElement("a");
    document.body.appendChild(a);
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = String(this.fileName);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  private b64toBlob(b64Data, contentType) {
    contentType = contentType || '';
    let sliceSize = 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  private setGaugeChartValues() {
    if (this.creditScore) {
      const element: any = document.querySelector('#gaugeArea');
      const isNoHistory = this.creditScore == 1 ? true : false;
      const { screenWidth, chartWidth } = this.updateGaugeChartValues(isNoHistory, element);
      this.updateScoreWithLegend(element, screenWidth, isNoHistory, chartWidth);
    }
  }

  private updateScoreWithLegend(element: any, screenWidth: number, isNoHistory: boolean, chartWidth: number) {
    const textElements = element.querySelectorAll("text");
    textElements.forEach((ele, index) => {
      if ((index !== textElements.length - 3) && (index !== textElements.length - 2)) {
        ele.style.fill = "#A4A4A4";
        ele.style.fontStyle = 'italic';
        ele.style.fontWeight = '400';
      } else if ((index !== textElements.length - 1)) {
        ele.style.fill = "#A4A4A4";
        ele.style.fontStyle = 'italic';
        ele.style.fontWeight = '900';
      }
    });
    const scoreElement = textElements[textElements.length - 1];
    try {
      const cibilreport = this.getScore();
      if (cibilreport) {
        var foreignObject = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "foreignObject"
        );
        foreignObject.setAttribute("width", "190");
        foreignObject.setAttribute("height", "70");

        if (screenWidth <= 300) {
          foreignObject.setAttribute("x", "40");
          foreignObject.setAttribute("y", "80");
        } else if (screenWidth <= 320) {
          foreignObject.setAttribute("x", "50");
          foreignObject.setAttribute("y", "80");
        } else {
          foreignObject.setAttribute("x", "100");
          foreignObject.setAttribute("y", "115");
        }
        var htmlContent = document.createElement("div");
        htmlContent.classList.add("cibil-value");
        htmlContent.innerHTML = `<div class="d-flex flex-column justify-content-center align-items-center py-2" style="line-height:2.3em;">
          <span class="cibil-report-status" style="color:${!isNoHistory ? cibilreport.color : '#00000'};font-size:${chartWidth <= 320 ? '14px' : '18px'};font-style:italic;font-weight:900;">${!isNoHistory ? cibilreport.classification : 'No-History'}</span>
          <span class="cibil-report-value" style="color:${!isNoHistory ? cibilreport.color : '#00000'};font-size:30px;font-weight:900">${!isNoHistory ? this.creditScore : 'NH'}</span>
          </div>`;
        foreignObject.appendChild(htmlContent);
        scoreElement.parentElement.replaceChild(foreignObject, scoreElement);
      }
    }
    catch (err) {
      scoreElement.parentElement.replaceChild(scoreElement, scoreElement);
    }
  }

  private updateGaugeChartValues(isNoHistory: boolean, element: any) {
    // Properties of the gauge
    const gaugeOptions = {
      hasNeedle: !isNoHistory ? true : false,
      needleColor: '#000000',
      arcColors: !isNoHistory ? ['#D90E44', '#FF8A36', '#F1DD2F', '#0DCB7B', '#05AC34'] : ['#A4A4A4', '#A4A4A4', '#A4A4A4', '#A4A4A4', '#A4A4A4'],
      arcDelimiters: [55, 65, 75, 85],
      arcPadding: 4,
      arcPaddingColor: 'white',
      arcLabels: ['722', '747', '764', '777'],
      arcLabelFontSize: 12,
      rangeLabel: ['Improve', 'Excellent'],
      centralLabel: !isNoHistory ? this.creditScore : 'NH',
      centralLabelFontSize: 30,
      rangeLabelFontSize: 14,
      labelsFont: 'Lato',
      outerRadius: 2
    };
    // Get the screen width
    const screenWidth: number = window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    // Set the width of the chart based on the screen width
    const chartWidth: number = screenWidth <= 320 ? screenWidth - 20 : 400;
    GaugeChart.gaugeChart(element, chartWidth, gaugeOptions).updateNeedle(this.creditScoreToPercentage(Number(this.creditScore) ?? 0));
    element.style.height = "200px";
    return { screenWidth, chartWidth };
  }

  private getScore() {
    if (this.creditScore) {
      if (this.creditScore <= 722) {
        return { color: "#D90E44", classification: "Improve" };
      } else if (this.creditScore <= 747) {
        return { color: "#FF8A36", classification: "Fair" };
      } else if (this.creditScore <= 764) {
        return { color: "#F1DD2F", classification: "Good" };
      } else if (this.creditScore <= 777) {
        return { color: "#0DCB7B", classification: "Very Good" };
      } else {
        return { color: "#05AC34", classification: "Excellent" };
      }
    } else {
      return null;
    }
  }

  private handleRouteData() {
    let cibilData: any = this.storageService.getObject(Keys.CIBIL_DATA);
    if (cibilData) {
      this.creditScore = cibilData.creditScore ? cibilData.creditScore : null;
      this.monthlyIncome = cibilData.livelihoodInfo && cibilData.livelihoodInfo.income ? cibilData.livelihoodInfo.income : 0;
      this.creditReportId = cibilData.creditReportId ? cibilData.creditReportId : null;
      this.email = cibilData.personalInfo && cibilData.personalInfo.email ? cibilData.personalInfo.email : null;
      this.panCard = cibilData.pan ? cibilData.pan : null;
      this.isNoHistory = cibilData.noHistory ? cibilData.noHistory : false;
      this.employmentType = cibilData.livelihoodInfo && cibilData.livelihoodInfo.employmentType ? cibilData.livelihoodInfo.employmentType : '';
    }
  }

  private async getCibilReportContent(): Promise<void> {
    if (this.creditReportId) {
      try {
        const creditReport: CreditReportFetchResponse = await this.creditBureauService.getCreditReportById(this.creditReportId);
        if (creditReport) {
          this.fileContent = creditReport.fileContent;
          this.fileName = creditReport.fileName;
          this.creditBureauUniqueReferenceId = creditReport.creditBureauUniqueReferenceId;
        } else {
          Toaster.toast('The credit report not found for a given ID', Type.Alert);
        }
      } catch (err) {
        Toaster.toast('Something went wrong! Please try again later.', Type.Error);
      }
    }
  }

  // This method is used to adjust the needle respective to score
  private creditScoreToPercentage(cibilScore: number) {
    if (cibilScore >= 300 && cibilScore <= 722) {
      // Range: 300 - 722
      return ((cibilScore - 300) / (722 - 300)) * 55; // Adjust the scale as needed
    } else if (cibilScore >= 723 && cibilScore <= 747) {
      // Range: 723 - 747
      return 55 + ((cibilScore - 723) / (747 - 723)) * 10;
    } else if (cibilScore >= 748 && cibilScore <= 764) {
      // Range: 748 - 764
      return 66 + ((cibilScore - 748) / (764 - 748)) * 10;
    } else if (cibilScore >= 765 && cibilScore <= 777) {
      // Range: 765 - 777
      return 76 + ((cibilScore - 765) / (777 - 765)) * 10;
    } else if (cibilScore >= 778 && cibilScore <= 900) {
      // Range: 778 - 900
      return 86 + ((cibilScore - 778) / (900 - 778)) * 20;
    } else {
      // Handle invalid input
      return -1;
    }
  }

  // private indicativeLoanAvailabilityCheckForUser(event: any) {
  //   this.isQuickCashAvailable = event;
  // }

  private async checkIndicativeLoanOffer(creditReportId: string, monthlyIncome: number): Promise<void> {
    if (this.employmentType && this.employmentType === 'SALARIED' && this.monthlyIncome && this.monthlyIncome >= this.minimumSalariedIncome) {
      const body = {
        creditReportId,
        monthlyIncome
      };

      const indicativeOfferResponse = await this.creditAssessmentService.getIndicativeLoanOffer(body);

      try {
        if (indicativeOfferResponse) {
          if ((indicativeOfferResponse.status === 'SUCCESS') && indicativeOfferResponse.indicativeLoanOffers && indicativeOfferResponse.indicativeLoanOffers.length) {
            this.indicativeLoan = indicativeOfferResponse.indicativeLoanOffers[0];
          } else if (indicativeOfferResponse.statusCode && indicativeOfferResponse.statusCode === IndicativeLoanOfferStatusCode.DPD_OR_SETTLEMENT_EVENTS_OCCURRED) {
            this.showNoLoanOffer = true;
          } else {
            this.showNormalPersonalLoan = true;
          }
        }
      } catch (err) {
        Logger.log(`Unable to fetch indicative loan offer for ${this.panCard} ${err}`);
      }
    } else {
      this.showNormalPersonalLoan = true;
    }
  }

  // private getAllCreditReportsOfLenderByPanCard() {
  //   this.creditBureauService.getAllCreditReports(this.panCard)
  //     .then((res) => {
  //       console.log("getAllCreditReportsOfLenderByPanCard : ", res)
  //     })
  //     .catch((err) => {
  //       Logger.log(`Unable to fetch credit reports for  ${this.panCard} ${err}`);
  //       // Toaster.toast(`Something went wrong while fetching all credit reports`, Type.Error);
  //     })
  // }

  // navigateToLoanInfo() {
  //   this.removeLoanApplicationFromLocalStorage();
  //   this.router.navigate(['/borrow/loan-info']);
  // }

  private removeLoanApplicationFromLocalStorage() {
    this.storageService.removeItem(Keys.LOAN_APPLICATION);
  }
}
